import axios from "axios"
import webconfig from '../../src/webconfig.json'
import { getUser } from '../auth/oidc-user'

const apiTCEComunica = axios.create({
  baseURL: webconfig.ApiTCEComunica,
})

apiTCEComunica.interceptors.request.use(async config => {
  const token = getUser().access_token
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }

  return config
})

export default apiTCEComunica